import { CarouselItem } from "../Carousel/CarouselItem";
import { ProductDetailPageResult } from "../ProductDetailPageResult";
import fetchRecommendationCarouselItems from "./fetchRecommendationCarouselItems";
import getCarouselItemsList from "./getNonRecommendationCarouselItemsList";
import { getSpecifications } from "./util";

interface GetRecommendationCarouselItemsParams {
  activeTemplate: ProductDetailPageResult;
  modelName: string;
  abVariation: string;
  isMounted: () => boolean;
  setEventName: (eventName: string) => void;
  setEventLabel: (eventLabel: string) => void;
  setRecommendationCarouselItems: (items: CarouselItem[]) => void;
}

export const getRecommendationCarouselItems = async ({
  activeTemplate,
  modelName,
  abVariation,
  isMounted,
  setEventName,
  setEventLabel,
  setRecommendationCarouselItems,
}: GetRecommendationCarouselItemsParams) => {
  const listOfExcludedItemNumbersFromOtherCarousels =
    getCarouselItemsList(activeTemplate);

  const specifications = getSpecifications(activeTemplate);

  const recommendationCarouselItems = await fetchRecommendationCarouselItems(
    activeTemplate.groupingAttributes.isGroupMaster
      ? activeTemplate.originalId
      : activeTemplate.itemNumber,
    activeTemplate.title,
    listOfExcludedItemNumbersFromOtherCarousels,
    modelName,
    specifications,
    abVariation,
  );

  if (recommendationCarouselItems.isError) return;

  if (isMounted()) {
    setEventName(recommendationCarouselItems.value.event);
    setEventLabel(recommendationCarouselItems.value.eventLabel);
    setRecommendationCarouselItems(recommendationCarouselItems.value.items);
  }
};
